import { useSelector } from 'react-redux';
import Initialize from '../../../modules/Initialize';
import { getActiveStore } from 'src/modules/Redux';
import useActiveScreenComponent from './hooks/useActiveScreenComponent';
import { useEffect, useMemo } from 'react';
import { Global } from '@emotion/react';
import SocketManager from 'src/modules/Lib/websockets';
import { getFont, getFontSize } from 'src/modules/Redux/slices/screen';
import { useCacheBusting } from 'src/modules/Hooks/useCacheBusting';

export const WS = new SocketManager();

const Routing = () => {
    const store = useSelector(getActiveStore);

    const Component = useActiveScreenComponent();
    const font = useSelector(getFont);

    const fontSize = useSelector(getFontSize);
    const globalStyles = useMemo(() => {
        return {
            html: {
                fontFamily: font,
                fontSize: '24px',
            },
        };
    }, [fontSize, font]);

    useCacheBusting();

    useEffect(() => {
        if (store) {
            WS.connect();
            WS.storeId = store._id;
        }
    }, [store]);

    return (
        <>
            <Initialize />
            <Global styles={globalStyles} />
            <Component />
        </>
    );
};

export default Routing;
